module.exports = __webpack_public_path__ + "img/IMG_9701_L_WoodMatted.d7707199.jpg";